module.exports = __webpack_public_path__ + "img/product-2-xty.23ffa71e.png";